/* import __COLOCATED_TEMPLATE__ from './test-settings-modal.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import type { PlaygroundSettings } from 'embercom/lib/fin-playground/settings';
import type UserSummary from 'embercom/objects/inbox/user-summary';
import { tracked } from '@glimmer/tracking';
import type InboxSearchSuggestionsService from 'embercom/services/inbox-search-suggestions-service';
import { inject as service } from '@ember/service';
import { dropTask } from 'ember-concurrency-decorators';
import type { TaskGenerator } from 'ember-concurrency';
import { taskFor } from 'ember-concurrency-ts';
import type Store from '@ember-data/store';
// @ts-ignore
import PredicateGroup from 'predicates/models/predicate-group';
// @ts-ignore
import { copy } from 'ember-copy';
interface TestSettingsModalArgs {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  playgroundSettings: PlaygroundSettings;
  withBrandDropdown?: boolean;
  withUserDropdown?: boolean;
}

export default class TestSettingsModal extends Component<TestSettingsModalArgs> {
  @tracked user: UserSummary | null = null;
  @tracked storedUser: UserSummary | null = null;
  @service declare inboxSearchSuggestionsService: InboxSearchSuggestionsService;
  @service declare store: Store;
  @tracked ruleset: $TSFixMe;
  @tracked inSearchMode = false;
  @service declare appService: $TSFixMe;
  constructor(owner: any, args: TestSettingsModalArgs) {
    super(owner, args);
    if (args.playgroundSettings.userId) {
      taskFor(this.loadStoredUser).perform(args.playgroundSettings.userId);
    }

    this.ruleset = this.setUpRuleset();
  }

  get userTargetingEnabled() {
    return this.args.withUserDropdown;
  }

  get brandIsDisabled() {
    return this.userTargetingEnabled && !this.user;
  }

  @dropTask
  *loadStoredUser(userId: string): TaskGenerator<void> {
    this.user = yield this.inboxSearchSuggestionsService.loadUserFromId(userId);
    this.storedUser = this.user;
  }

  @action
  save() {
    this.args.onSave();
    this.storedUser = this.user;
    this.onClose();
  }

  @action
  toggleSearchMode() {
    this.inSearchMode = !this.inSearchMode;
  }

  @action
  onCancel() {
    this.args.playgroundSettings.rollbackChanges();
    this.user = this.storedUser;
    this.onClose();
  }

  @action
  onClose() {
    this.inSearchMode = false;
    this.args.onClose();
  }

  @action
  onSelectUser(user: UserSummary | null) {
    if (user) {
      this.args.playgroundSettings.userId = user.id;
      this.user = user;
    } else {
      this.args.playgroundSettings.userId = null;
      this.args.playgroundSettings.brandId = null;
      this.user = null;
    }
  }

  @action
  handleBrandSelection(brandId: string | null) {
    this.args.playgroundSettings.brandId = brandId;
  }

  @action
  onUpdatePredicates(predicates: $TSFixMe) {
    this.ruleset.set('predicateGroup.predicates', copy(predicates));
    this.ruleset.fetchAudiencePreviewTask.perform();
  }

  @action
  onUpdateRolePredicates(predicates: $TSFixMe) {
    this.ruleset.set('rolePredicateGroup.predicates', copy(predicates));
    this.ruleset.fetchAudiencePreviewTask.perform();
  }

  setUpRuleset() {
    let newRuleset = this.store.createRecord('matching-system/ruleset');
    newRuleset.set('predicateGroup', this.store.createFragment('predicates/predicate-group'));
    newRuleset.set('clientPredicateGroup', this.store.createFragment('predicates/predicate-group'));
    // must properly define the default user roles to be all of them
    newRuleset.set(
      'rolePredicateGroup',
      this.store.createFragment('predicates/predicate-group', {
        predicates: PredicateGroup.convertRawPredicates(this.store, [
          {
            attribute: 'role',
            comparison: 'in',
            type: 'role',
            value: ['user_role', 'contact_role'],
          },
        ]),
      }),
    );
    newRuleset.set(
      'defaultPredicateGroup',
      this.store.createFragment('predicates/predicate-group'),
    );

    return newRuleset;
  }

  @action
  resetToDefaultSettings() {
    this.onSelectUser(null);
    this.handleBrandSelection(null);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::Modals::TestSettingsModal': typeof TestSettingsModal;
  }
}
